import React from 'react';
import styled from 'styled-components';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../utils/mobileSupported';
import { isMobile, isTablet } from 'react-device-detect';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { numberWithCommas } from 'shared/utils/number';

const BattlesReward = ({ battlesAssets, battlesFeatureState }) => {
  return (
    <InfoContainer source={battlesAssets.BATTLES_INFO_BOX}>
      <InfoText
        dangerouslySetInnerHTML={{
          __html: getText(TEXT_KEY.BATTLES_FINISH_STREAK),
        }}
      />
      <InfoAmountContainer>
        <CoinIcon src={assetSource(ASSET_KEY.COIN_ICON)} alt="Coin Icon" />
        <Amount>{numberWithCommas(battlesFeatureState?.currentStreak?.grandRewardAmount ?? 0)}</Amount>
      </InfoAmountContainer>
    </InfoContainer>
  );
};

export default BattlesReward;

const isMobileBrowser = isMobile && isNotStandaloneMobilePWA && !isTablet;
const isMobilePwa = isStandalonePWA && !isTablet;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 105%;
  height: ${isMobileBrowser ? 69 : 75}%;
  justify-content: center;
  align-items: center;
  background-image: url(${({ source }) => source});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  position: relative;
  top: unset;
  padding: ${isMobilePwa ? '22vh 0 0 0' : isTablet ? '15vh 0 0 0' : isMobileBrowser ? '17vh 0 0 0' : '10vw 0 0'};
  ${isMobile && !isTablet && 'margin-bottom: 2.8vh;'}

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-browser') &&
    `
    width: 100%;
    height: 65%;
  `}

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.device('mobile-standalone') &&
    `
    height: 80%;
  `}

  ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.device('mobile-standalone') &&
    `
    height: 78%;
    top: 1vh;
  `}

   ${({ theme }) =>
    theme.platform('ios') &&
    theme.screens.device('mobile-browser') &&
    `
    height: 40.3vh;
    top: 1vh;
  `}
`;

const InfoText = styled.span`
  color: #ffffff;
  font-size: 2.2vw;
  text-align: center;
  line-height: 1.2;
  font-weight: 600;
  text-transform: uppercase;

  ${({ theme }) => theme.BattlesReward.InfoText}
  ${({ theme }) => theme.screens.device('mobile-browser') && 'font-size: 1.5vw;'}
`;

const InfoAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  
  ${({ theme }) => theme.BattlesReward.InfoAmountContainer}
`;

const CoinIcon = styled.img`
  position: relative;
  width: 3vh;
  height: 3vh;
  margin: 0 0.25vh;
  top: 3px;
`;

const Amount = styled.span`
  color: #ffffff;
  font-size: 2.2vw;
  text-align: center;
  line-height: 1.2;
  font-weight: 800;
  text-transform: uppercase;
  
  ${({ theme }) => theme.BattlesReward.Amount}
  ${({ theme }) => theme.screens.device('mobile-browser') && 'font-size: 1.7vw;'}
`;

